import { useContext, useState } from 'react';
import {
  AppBar,
  Typography,
  Grid,
  Toolbar,
  IconButton,
  Button,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AccionaIcon } from '../../../assets/accionaIcon.svg';
import navbarStyle from './navbarStyle';
import { namespaces } from '../../../i18n/i18n.constants';
import { Version } from '../../Version/Version';
import { AuthContext } from '../../../services/authContextProvider';
import { ExportsModal } from '../Exports/ExportsModal';

export const Navbar = () => {
  const classes = navbarStyle();
  const { t } = useTranslation(namespaces.pages.navbar);
  const authContextProvider = useContext(AuthContext);
  const [exportsOpen, setExportsOpen] = useState(false);

  return (
    <AppBar
      position="static"
      elevation={0}
      className={classes.appBar}
    >
      <Toolbar
        className={classes.toolbar}
        style={{ minHeight: '3rem' }}
      >
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <IconButton disabled>
              <AccionaIcon className={classes.accionaIcon} />
              <Version />
            </IconButton>
          </Grid>
          <Grid item>
            <Grid container alignItems="center">
              <Typography variant="body2" color="inherit" fontWeight="bold">
                <Button
                  variant="contained"
                  size='large'
                  disableElevation
                  onClick={() => setExportsOpen(true)}
                  className={classes.root}
                >
                  {t('exports')}
                </Button>
                <Button
                  variant="contained"
                  size='large'
                  disableElevation
                  onClick={authContextProvider.logout}
                  className={classes.root}
                >
                  {t('logout')}
                </Button>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
      <ExportsModal open={exportsOpen} onClose={() => setExportsOpen(false)} />
    </AppBar>
  );
};
